import { Button } from '../../../blaze-ui/Button'
import { DropdownTrigger } from 'components/DropdownTrigger/DropdownTrigger'
import { cloneElement, ReactNode, useEffect } from 'react'
import Styles from './HelpDropdown.module.scss'
import { focusModeSet } from 'redux/actions/focusMode'
import store from 'redux/store'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { Placement } from '@floating-ui/react-dom'
import { Help } from 'blaze-ui/icons'
import { Pressable, PressResponder } from '@react-aria/interactions'
import { HelpSections } from './HelpSections'
import { useRootStore } from 'stores/RootStore'
import { HelpDrawer } from './HelpDrawer'
import { WizardType } from 'components/Wizards/schemas/Types'

interface Props {
  trigger?: ReactNode
  placement?: Placement
  allowOnboarding?: boolean
  videoTutorialType?: WizardType
}

export const HelpDropdown = ({
  trigger,
  placement = 'bottom-end',
  allowOnboarding = true,
  videoTutorialType,
}: Props) => {
  const { isMobile } = useResponsiveDesign()
  const { drawersStore } = useRootStore()

  useEffect(() => {
    const onEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        store.dispatch(focusModeSet({ showFocusMode: false, manual: false }))
      }
    }
    document.body.addEventListener('keydown', onEscape)
    return () => document.body.removeEventListener('keydown', onEscape)
  }, [])

  // Open a drawer with the items on mobile instead of the popover
  if (isMobile) {
    const localTrigger = trigger ? (
      <Pressable>
        <div>{trigger}</div>
      </Pressable>
    ) : (
      <Button variant="tertiary" size="lg" frontIcon={Help} rounded />
    )

    return (
      <div>
        <PressResponder
          isPressed={false}
          onPress={() =>
            drawersStore.openDrawer(HelpDrawer, {
              close: drawersStore.closeAllDrawers,
              videoTutorialType,
            })
          }
        >
          {cloneElement(localTrigger)}
        </PressResponder>
      </div>
    )
  }

  return (
    <div>
      <DropdownTrigger placement={placement} popoverClassName={Styles.dropdownContainer}>
        {trigger ? (
          <Pressable>
            <div>{trigger}</div>
          </Pressable>
        ) : (
          <Button variant="tertiary" size="lg" frontIcon={Help} rounded>
            {!isMobile ? 'Help' : null}
          </Button>
        )}

        {(close) => <HelpSections close={close} videoTutorialType={videoTutorialType} />}
      </DropdownTrigger>
    </div>
  )
}
